/**
 * @param {Object} props
 * @param {string | undefined} [props.className]
 * @returns {React.ReactElement} The rendered component
 */
const HeartIcon = ({ className }) => (
  <svg
    className={className}
    width="25px"
    height="23px"
    viewBox="0 0 400 400"
    version="1.2"
    baseProfile="tiny"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      fill="currentColor"
      d="M396.7 94.1c-6.1-21.1-19.7-42.5-45-62.7-1.1-.9-6.4-4.2-7.9-4.9-74.1-35.5-129.2 23.1-143 40-13.9-17-69.9-76.5-145-39-.8.4-1.6 1-6.1 4C23.2 52.4 10.9 73 4.8 94.1h391.9zM382.8 187.1c8.6-16.6 15.8-36.1 17.2-57.1H0c1.4 21 8.6 40.5 17.2 57.1h365.6zM90.6 276.4h215.5c22.7-25.2 40-44.9 40-44.9s5.1-5.5 11.9-14.3H38.7c6.8 8.8 11.9 14.3 11.9 14.3s17.3 19.7 40 44.9M130.6 315.8c34.2 35.3 68.5 69 75 69s40.8-33.6 75-69h-150z"
    />
  </svg>
);

export default HeartIcon;
